window.slate = window.slate || {};
window.theme = window.theme || {};
/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        checkItemCount(this.currentVariant);

        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    function checkItemCount(s)
    {
        var va = inv_qty[s.id];

        if(va > 0 && va < 10)
        {
            $('.left-items').addClass('active');
            var pr = (va*10)+"%";
            $('.left-items .bar-color').css({'width':pr});
            $('.bar-text').text(s.title + ": Only "+va+" remaining");
        }
        else
        {
            $('.left-items').removeClass('active');
            $('.left-items .bar-color').css({'width':'100%'});
        }

        // this is temp for product notifcation
        if(va <= 0) $('.klaviyo-bis-trigger').show();
        else $('.klaviyo-bis-trigger').hide();



    }

    $('.size-select-div >divxxx').click(function (e) {

        e.preventDefault();
        $('.size-select-div >div').removeClass('active');
        $(this).addClass('active');
        var ind =  $(this).index();

        $('.selector-wrapper.size select').val($('.selector-wrapper.size select option').eq(ind).val()).change();

        if( $('.selector-wrapper.title  select').length)
        {
            $('.selector-wrapper.title  select').val($('.selector-wrapper.title select option').eq(ind).val()).change();

        }

    });

    $('.size-select-div >div').click(function (e) {

        e.preventDefault();
        // $('.size-select-div >div').removeClass('active');
        $(this).parent().find('>div').removeClass('active');
        $(this).addClass('active');
        var ind =  $(this).index();

        var sel = $(this).parents('.size-select-div').next().find('select');
        sel.val(sel.find('option').eq(ind).val()).change();

        /*

        $('.selector-wrapper.size select').val($('.selector-wrapper.size select option').eq(ind).val()).change();

        if( $('.selector-wrapper.title  select').length)
        {
            $('.selector-wrapper.title  select').val($('.selector-wrapper.title select option').eq(ind).val()).change();

        }*/

    });

    Variants.prototype = $.extend({}, Variants.prototype, {

        /**
         * Get the currently selected options from add-to-cart form. Works with all
         * form input elements.
         *
         * @return {array} options - Values of currently selected variants
         */
        _getCurrentOptions: function () {
            var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                }
            });

            // remove any unchecked input values if using radio buttons or checkboxes
            currentOptions = slate.utils.compact(currentOptions);

            return currentOptions;
        },

        /**
         * Find variant based on selected values.
         *
         * @param  {array} selectedValues - Values of variant inputs
         * @return {object || undefined} found - Variant object from product.variants
         */
        _getVariantFromOptions: function () {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = false;

            variants.forEach(function (variant) {
                var satisfied = true;

                selectedValues.forEach(function (option) {
                    if (satisfied) {
                        satisfied = (option.value === variant[option.index]);
                    }
                });

                if (satisfied) {
                    found = variant;
                }
            });

            return found || null;
        },

        /**
         * Event handler for when a variant input changes.
         */
        _onSelectChange: function () {
            var variant = this._getVariantFromOptions();

            checkItemCount(variant);

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this.currentVariant = variant;

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        /**
         * Trigger event when variant image changes
         *
         * @param  {object} variant - Currently selected variant
         * @return {event}  variantImageChange
         */
        _updateImages: function (variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        /**
         * Trigger event when variant price changes.
         *
         * @param  {object} variant - Currently selected variant
         * @return {event} variantPriceChange
         */
        _updatePrice: function (variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },

        /**
         * Update history state for product deeplinking
         *
         * @param {object} variant - Currently selected variant
         */
        _updateHistoryState: function (variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({path: newurl}, '', newurl);
        },

        /**
         * Update hidden master select of variant change
         *
         * @param {object} variant - Currently selected variant
         */
        _updateMasterSelect: function (variant) {
            $(this.originalSelectorId, this.$container)[0].value = variant.id;
        }
    });

    return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

        $('.select-top').text(variant.public_title);

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }



      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);

                 $(selectors.addToCartText, this.$container).html("ADD TO CART");


      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html("SOLD OUT");
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 *created By Nalinda - Home page hero banners
 */

"use strict"

var TJ = (typeof TJ === 'object') ? TJ : {};

TJ.hero = {
    VAR: {
        $MainContent: $('#MainContent'),
        winwidth: 0,
        heroWidth: 1920,
        heroHeight: 845,
        maxWidth: 1500
    },
    init: function () {
        var _this = this;

        $('.hero-slider').slick({


            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',


            pauseOnHover: false, slidesToShow: 1, slidesToScroll: 1, dots: true, arrows: true,
            autoplay: true,
            autoplaySpeed: 6000, infinite: true,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        dots: false, arrows: false
                    }
                }
            ]

        });

        $(window).on('uti-width-changed', function () {
            var videocontainer = $('.hero-vid');
            var exwid = $(window).width()+3;
            videocontainer.width(exwid);
            videocontainer.css("left","-1px").css("position","relative");
            if (UTI.isdesktop)
            {
                videocontainer.height(exwid * (845/1920 ));
            }
            else
            {
                videocontainer.height(exwid * (1350/1080 ));
            }
        })


        $(window).on('uti-device-changed', function () {

            var newmp4 = $('.hero-sou').attr('data-m');
            if (UTI.isdesktop) {
                newmp4 = $('.hero-sou').attr('data-d');
            }

            var videocontainer = $('.hero-vid');
            var videosource = $('.hero-sou');

            if(videocontainer.length)
            {
                videocontainer.get(0).pause();
                videosource.get(0).setAttribute('src', newmp4);
                videocontainer.get(0).load();
                videocontainer.get(0).play();
            }



        });
    }

};



/**
 *created By Nalinda
 */

"use strict"

var TJ = (typeof TJ === 'object') ? TJ : {};

TJ.collection = {
    VAR: {

    },
    init: function () {

        $('body').on('click','.bc-sf-filter-option-item',function(){
            $(this).parents('.bc-sf-filter-block-content').find('.bc-sf-filter-select-button').trigger('click');
        });


       $('body').on('click','#bc-sf-filter-tree-mobile-button-custom, .mob-filter-apply button, .mob-filter-close',function(){
           $('body').toggleClass('filter-open');

           if(!$('body').hasClass('filter-open'))
           {
               UTI.common.scrollTo(0);
           }
       });



        $('body').on('click','.desk-filter',function(){
            if(!UTI.isdesktop)
            {
                $('#bc-sf-filter-tree-mobile-button').trigger('click');
            }

        });

        $('body').on('click','.bc-sf-filter-filter-dropdown a',function(){
            UTI.common.scrollTo(0);
        });


        /*
              // cllapse function in collection filters

                $('body').on('click','.bc-sf-top .closing',function(e){

                  e.preventDefault();
                  $(this).toggleClass('close');
                  $('.bc-sf-left').toggleClass('close');
                });



                $(window).on('scroll', function () {

                    var  tops= $('header .banner').offset().top +  $('header .banner').height()-53;

                    if(window.pageYOffset > tops)
                    {
                        if(!$('body').hasClass('stick-filter'))
                        {
                            $('body').addClass('stick-filter');
                        }
                    } else
                    {
                        if($('body').hasClass('stick-filter'))
                        {
                            $('body').removeClass('stick-filter');
                        }
                    }
                });

                $('body').on('click','.mobile-top .close, .mobile-bottom',function(e){

                    e.preventDefault();
                    $('body').removeClass('mob-filter-open');
                });


                $('body').on('click','.mob-fil a',function(e){
                    e.preventDefault();
                    e.stopPropagation()
                    $('body').addClass('mob-filter-open');
                });


                $('body').on('click','.filter-close .bc-sf-filter-clear-all',function(e){

                    e.preventDefault();
                    $('#bc-sf-filter-tree .bc-sf-filter-clear-all').trigger('click');
                });


                $(window).on('filterloads',function(e){
                    $('.filter-close').html("");
                    $('.filter-close').append($('.bc-sf-filter-selection-wrapper').clone());
                });



        */




    }

};

// $(function () {
//     TJ.collection.init();
// });

"use strict"

var TJ = (typeof TJ === 'object') ? TJ : {};

TJ.pdp = {
    VAR: {},
    init: function () {
        var _this = this;
        const productSlider = $('.product-top .gallery .image .gallery-big');
        const mediaQuery = window.matchMedia('(max-width: 768px)');

        const handleSwitchSlick = ((e) => {
            if (e.matches) {
                productSlider.slick({
                    slidesToShow:1,
                    infinite: false,
                    dots: true,
                    touchThreshold: 20,
                    arrows: false,
                    nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
                    prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
              });
            } else if (productSlider.hasClass('slick-initialized')) {
                productSlider.slick('unslick');
            }
          });

          mediaQuery.addListener(handleSwitchSlick);
          handleSwitchSlick(mediaQuery);

        // $('.product-top .gallery .image .gallery-big').slick({

        //     slidesToShow:2,
        //     slidesToScroll: 1,
        //     infinite: false,
        //     dots: false,
        //     touchThreshold: 20,
        //     arrows: true,
        //     adaptiveHeight: true,
        //     nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
        //     prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
        //     responsive: [
        //         {
        //             breakpoint: 768,
        //             settings: {
        //                 slidesToShow: 1,
        //                 dots: true,
        //                 arrows:false
        //             }
        //         }
        //     ]
        // });





        $(window).on('uti-device-changed', function () {
            if (UTI.isdesktop) {
                var $easyzoom = $('.easyzoom').easyZoom();
                var api = $easyzoom.data('easyZoom');
            }
        });

        if(Modernizr.touchevents)
        {
            $('.zoomLoaderMessage').hide();
            $('.easyzoom a').click(function(e)
            {
                e.preventDefault();
            });
        }

        var counter = 0;
        if(jQuery('.insta-pdp').length)
        {
            var is = setInterval(function(){
                if(jQuery('.insta-pdp .fs-entry-container').length)
                {
                    _this.instaSliders();
                    clearInterval(is);
                }

                if (counter >= 5)
                {
                    clearInterval(is);
                    jQuery('.insta-pdp').hide();
                }
                counter++;

            },1000);
        }


        // findmysize start

        $('#ff-first--wrapper button').on('click',function () {
            $('#ff-select--wrapper').fadeIn();
        })

        var fabricHeading = $('.psd-left h4:contains(Fabric)');
        fabricHeading.text(fabricHeading.text().replace('Fabric','Details'));

        var ff = '#find-my-size',
            ffSelect = '#find-my-size select';

        $('.ff-measurement-selector').on('click',function(e) {
            e.preventDefault();
            var myUnit = $(this).data('fit-units');
            $('.ff-measurement-selector').removeClass('active');
            $(ff + ' option').hide().filter('[data-units*="'+myUnit+'"]').show();
            $(ffSelect).val('must-select').trigger('change');
            $(this).addClass('active');
        });

        var sizesToCheck = [];

        $(ffSelect).on('change',function() {
            if($(this).val() != 'must-select') {
                $(this).removeClass('error');
            }
        });
        /* Some functions */
        Array.max = function( array ){
            return Math.max.apply( Math, array );
        };
        Array.min = function(array) {
            return Math.min.apply( Math, array );
        };

        function findMySize(arr) {

            var min = Array.min(arr),
                max = Array.max(arr);
            var mid = (max+min) / 2;
            var midSize = Math.ceil(mid - 1);


            $('.ff-result').text(sizelist[arr[0]-1][arr[1]-1]);

            var sel;
            $('.size-select-div >div').each(function(){
                if($(this).text() == sizes[midSize])
                {
                    sel = $(this);
                    $(this).trigger('click');
                    UTI.common.scrollTo(0);
                }
            });




           // $('.variant-select__list .variant-select__option-label[data-value="'+sizes[midSize]+'"]').trigger('click');

        }

        $('.find-my-size--submit').on('click',function(e) {
            e.preventDefault();
            sizesToCheck = [];
            var allSelected = true;
            $(ffSelect).each(function(i,v) {
                if($(this).val() === 'must-select') {
                    $(this).addClass('error');
                    allSelected = false;
                } else {
                    var valueToPush = { };
                    var myIndex = $(this).data('selectedIndex') - 1;
                    var myIndex = $(this).find(':selected').data('index');
                    //valueToPush[0] = myIndex - 1;
                    //valueToPush[1] = $(this).val();
                    //sizesToCheck.push($(this).val());
                    sizesToCheck.push(myIndex+1);
                }
            });
            if(allSelected) {
                findMySize(sizesToCheck);
                $('#ff-results--wrapper').fadeIn();

            }
            //console.log(allSelected);
        });

        $('.find-my-size--return').on('click',function(e) {
            e.preventDefault();
            $('#ff-results--wrapper').fadeOut();
        });

        $('[data-fixpop="enq-pop"]').click(function(){

            $('#find-my-size>div').hide();
            $('#find-my-size>div').eq(0).show();
        });

    },
    instaSliders: function () {
        var _this = this;
        jQuery('.insta-pdp .fs-timeline').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,infinite: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        $('.fs-timeline').addClass('slickadded');


        $('body').on('click', '.insta-pdp .fs-timeline .hero-next', function (e) {
            if(!$(this).hasClass('slick-disabled'))
            {
                $('html, body').scrollTop( $('html, body').scrollTop()+1);
            }

        });


    },relgal:function(){

        jQuery('.rec-wrap').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        if($(window).width() < 768)
        {
            $('.inside-- > a:not(.slick-slider)').slick({
                touchThreshold: 20,
                slidesToShow: 1,
                slidesToScroll: 1,infinite: false,dots:true, arrows:false
            });
        }


    }
};




/**
 *created By Nalinda - Blog
 */

"use strict"

var TJ = (typeof TJ === 'object') ? TJ : {};

TJ.blog = {
    VAR: {},
    init: function () {

        $('body').on('click','.pagi a',function(e){

            e.preventDefault();
            var link = $(this).attr('href')

            loadposts(link);


        });



        function loadposts(url) {

            var content;
            $.get(url, function (data) {
                content = $(data);

                //laod content
                $('.blog-list').append(content.find('.blog-list .item'));
                $('.pagi').html(content.find('.pagi').html());

                history.pushState({}, null, url);



            });

        }




    }

};



"use strict"

var AL = (typeof AL === 'object') ? AL : {};

AL.faq = {
    VAR: {},
    init: function () {

        $('.faq-title--').each(function (i, e) {

            if ($(this).hasClass('contact')) {
                $('.faq-links-in').append("<div class='faq-l'><a class='contact' href='"+ $(this).attr('data-link')+"'>" + $(this).html() + "</a></div>");
            } else {
                $('.faq-links-in').append("<div class='faq-l'><a href='#faq" + i + "'>" + $(this).html() + "</a></div>");
                $('.faq-title').eq(i).attr('id', "faq" + i);
            }


        });


        $('.faq-item-title').click(function (e) {
            e.preventDefault();

            $('.faq-item-wrap').slideUp();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
            else {
                $('.faq-item-title.active').removeClass('active');
                $(this).next().stop().slideDown();
                $(this).addClass('active');
            }

        });


        $('.faq-l-- a:not(".contact")').click(function (e) {
            e.preventDefault();
            UTI.common.scrollTo($($(this).attr('href')), 220, 300);
        });
        //change the title color

        $(window).on('scroll', function (a, b) {

           // checkPos(window.pageYOffset);
        });
        //checkPos(window.pageYOffset);

        function checkPos(scrolls) {
            var pos = 0;
            $('.faq-section').each(function () {
                if ($(this).offset().top < (scrolls + 230)) {
                    pos = $(this).index();
                }
            });

            $('.faq-links .faq-l').removeClass('active');
            $('.faq-links .faq-l').eq(pos).addClass('active');


            if (scrolls > 100 && !$('body').hasClass('mobfaq')) {
                $('body').addClass('mobfaq');
            }
            else if ((scrolls < 100) && $('body').hasClass('mobfaq')) {
                $('body').removeClass('mobfaq');
            }

            if (!$('body').hasClass('insta')) {
                if (scrolls > $('.insta-set').offset().top - 500) {
                    $('body').addClass('insta');
                }
            }
            else if (scrolls <= $('.insta-set').offset().top - 500) {

                $('body').removeClass('insta');

            }


        }


    },

    changeScreen: function () {


    },


    navChange: function () {

    }
};



/*================ Common ================*/
"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};
UTI.isdesktop = true;

UTI.common = {
    VAR: {
        navClosed: false,
        windowwidth: 0,
        windowheight: 0,
        $MainContent: $('#MainContent'),
        lastDeviceDesktop: true
    },
    init: function () {
        var _this = this;

        $(window).resize(function () {
            //use nav menu text to detect mobile and desktop
            if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
                UTI.isdesktop = true;
                $(window).trigger('uti-device-changed');
            }
            else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
                UTI.isdesktop = false;
                $(window).trigger('uti-device-changed');
            }
            _this.checkResize();

        });


        setTimeout(function () {
            $(window).trigger('uti-device-changed');
            $(window).trigger('uti-width-changed');

        }, 100);

        //common function to change all the image with the dievice change
        $(window).on('uti-device-changed', function () {

            if (UTI.isdesktop) {
                $('[data-deskimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-deskimage'));
                });
            }
            else {
                $('[data-mobimage]').each(function () {
                    $(this).attr('src', $(this).attr('data-mobimage'));
                });
            }


        });




        //scroll throtle
        var scrollpos = 0;
        var scrollTimeout;
        var throttle = 200;

        $(window).on('scroll', function () {
            if (!scrollTimeout) {
                scrollTimeout = setTimeout(function () {
                    var goindown = window.pageYOffset>scrollpos?true:false;
                    scrollpos = window.pageYOffset;
                    $(window).trigger('utiscroll', [window.pageYOffset, goindown]);
                    scrollTimeout = null;
                }, throttle);
            }
            //var goindown = window.pageYOffset>scrollpos?true:false;
            //scrollpos = window.pageYOffset;
            //$(window).trigger('utiscroll', [window.pageYOffset, goindown]);
        });

        // simple accordion for all, use ac-title

        $( '.ac-title:not(.active)').each(function(){
            $(this).next().css('display','none');
        });

        $('body').on('click', '.ac-title', function (e) {

            e.preventDefault();
            e.stopPropagation();
            if ($(this).hasClass('active')) {
                $(this).next().removeClass('active');
                $(this).next().slideUp();
                $(this).find('i').attr('class', "fa fa-angle-down");
            }
            else {
                $(this).next().addClass('active');
                $(this).next().slideDown();
                $(this).find('i').attr('class', "fa fa-angle-up");
            }
            $(this).toggleClass('active');

        });

        //=============popup window for links with class popit-------------------------

        $('body').on('click', "[data-popit]", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var link = $(this).attr('href') + " " + $(this).attr('data-popit');

            $('<div>').dialog({
                modal: true, draggable: false,
                open: function () {
                    $(this).load(link, function() {
                       // $(".tableWrap").mCustomScrollbar({
                        //    axis: "x" // horizontal scrollbar
                        // });
                    });

                },
                height: "100%",
                width: "100%"
            });
        });
        $('body').on('click', ".ui-widget-overlay", function (e) {
            $('.ui-dialog-titlebar-close').trigger('click');
        });

        // adding default scroll x plugin for pages
        //$(".tableWrap").mCustomScrollbar({
          //  axis: "x" // horizontal scrollbar
       // });

        //=============----------------------------

        //to run with the fix popup

        $('body').on('click','[data-fixpop]',function(e){
            e.preventDefault();
            $('.'+$(this).attr('data-fixpop')).addClass('active');
            $('body').append('<div class="fix-pop-back"></div>');
            setTimeout(function(){
                $('body').addClass('pop-open');
            },100);

        });


        $('body').on('click','.fix-popup .close,.fix-pop-back',function(e){
            e.preventDefault();
            $('.fix-popup').removeClass('active');
            $('body').removeClass('pop-open');
            $('.fix-pop-back').remove();

        });

       // if (jQuery('.featured-slider').length) {
            _this.callSliders();
        //}



        if(jQuery('.insta-set').length)
        {
            var is = setInterval(function(){

                if(jQuery('.insta-set .fs-entry-container').length)
                {
                    _this.instaSliders();
                    clearInterval(is);
                }

            },1000);
        }

        // collection page
        $('body').on('beforeChange', '.inside > a:not(.comp)', function(event, slick, currentSlide, nextSlide){
            $(this).find('[data-isrc]').each(function(){
                $(this).attr('src', $(this).attr('data-isrc'));
            });
            $(this).addClass('comp');
        });

        //product slider load swatches
        $('body').on('mouseover','.pro-slide-no:not(.sw)',function(e){
            var swa = $(this).find('.load-swatches');
            $(this).addClass('sw');
            e.preventDefault();
            swa.text('Loading...');
            var thisa = swa.parent();
            var utlonly = swa.attr('href').split('?')[0];

            $.get(utlonly+"?view=swatch", function (data) {
                thisa.html($(data));
            }).done(function () {
               // $(this).parents('.color-options').html($(data));
            });
        });
/*
        $(window).on('load-color-swatch-no', function () {
            var thiss = $('.pro-slide:not(.sw)').eq(0);
            var swa = thiss.find('.load-swatches');
            thiss.addClass('sw');
            if(swa.length)
            {
                swa.text('Loading...');
                var thisa = swa.parent();
                var utlonly = swa.attr('href').split('?')[0];

                $.get(utlonly+"?view=swatch", function (data) {
                    thisa.html($(data));
                }).done(function () {
                    if($('.pro-slide:not(.sw)').length)
                    {
                        //$(window).trigger('load-color-swatch');
                    }
                });
            }else
            {
                if($('.pro-slide:not(.sw)').length)
                {
                   // $(window).trigger('load-color-swatch');
                }
            }

        });
*/
        // $(window).trigger('load-color-swatch');


        $('body').on('click','.swatchlink',function(e){
            e.preventDefault();
            var thisa = $(this).parents('.pro-slide');
            thisa.find('.swatchlink').removeClass('active');
            $(this).addClass('active');
            var datswatch = $(this).parents('.color-options').html();

            $.get($(this).attr('href')+"?view=slide", function (data) {
                thisa.html($(data));
            }).done(function () {

                thisa.find('.color-options').html(datswatch);

                if($(window).width() < 768)
                {
                    $('.inside-- > a:not(.slick-slider)').slick({
                        touchThreshold: 20,
                        slidesToShow: 1,
                        slidesToScroll: 1,infinite: false,dots:false, arrows:false
                    });
                }
            });
        });

        if($(window).width() < 768)
        {
            $('.inside-- > a:not(.slick-slider)').slick({
                touchThreshold: 20,
                slidesToShow: 1,
                slidesToScroll: 1,infinite: false,dots:false, arrows:false
            });
        }


    },
    checkResize: function () {
        var _this = this;
        if (_this.VAR.$MainContent.width() !== _this.VAR.windowwidth || $(window).height() !== _this.VAR.windowheight) {
            _this.VAR.windowwidth = _this.VAR.$MainContent.width();
            _this.VAR.windowheight = $(window).height();
            $(window).trigger('uti-width-changed');
        }
        _this.VAR.windowwidth = _this.VAR.$MainContent.width();
        _this.VAR.windowheight = $(window).height();
    },

    callSliders: function () {
        var _this = this;

        jQuery('.pro-slide').each(function(){
            var div = $(this).find('[data-f-src]');
            var divh = $(this).find('[data-fh-src]');
            if(UTI.isdesktop || !$(this).hasClass('.slide'))
            {
                divh.attr('src',divh.attr('data-fh-src'));
                div.attr('src',div.attr('data-f-src'));
            }
            else
            {
                if($(this).index() < 4)
                {
                    div.attr('src',div.attr('data-f-src'));
                }
            }

        });

        // slider auto scrolls on hover

        var timers;
        var thisbtn;
        $('body').on('mouseover','.hero-btn:not(.cl)',function(e){
            e.preventDefault();
            thisbtn = $(this);
            thisbtn.trigger('click');
            timers = setInterval(function(){
                thisbtn.trigger('click');
                if(thisbtn.parents('.insta-set').length)
                {
                    $("html, body").animate({scrollTop:  $(window).scrollTop()-0.01});
                }

            }, 1000);
        });

        $('body').on('mouseout','.hero-btn:not(.cl)',function(e){
            e.preventDefault();
            clearInterval(timers);
        });


        jQuery('.featured-slider').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
                nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
                prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: "unslick"
                }
            ]
        });

        //to change side arrows
        $(window).on('uti-width-changed', function () {

            var vv = _this.VAR.windowwidth > 1641 ? jQuery('.featured-slider').addClass("big") : jQuery('.featured-slider').removeClass("big");

        });


    },


    // scroll to function
    scrollTo: function (targetElement, offset, duration) {
        var scrollAmount = 0;
        if (!isNaN(targetElement)) {
            scrollAmount = targetElement;
        } else {
            targetElement = targetElement instanceof jQuery ? targetElement : $(targetElement);
            offset = offset || 0;
            duration = duration || 200;
            scrollAmount = targetElement.offset().top - offset;
        }

        $('html, body').animate({
            scrollTop: scrollAmount
        }, duration);
    },

    instaSliders: function () {
        var _this = this;
        jQuery('.insta-set .fs-timeline').slick({
            touchThreshold: 20,
            // centerMode: true,
            // variableWidth: false,
            nextArrow: '<div class="hero-next hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306;" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',
            prevArrow: '<div class="hero-prev hero-btn"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 306 306" style="enable-background:new 0 0 306 306; transform: rotate(180deg);" xml:space="preserve"><g><g id="chevron-right" style="fill:#FFFFFF"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153 \t\t"/></g></g></svg></div>',

            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 1,infinite: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 747,
                    settings: "unslick"
                }
            ]
        });

        $('.fs-timeline').addClass('slickadded');
        $('body').on('click', '.insta-set .fs-timeline .hero-next', function (e) {
            if(!$(this).hasClass('slick-disabled'))
            {
                $('html, body').scrollTop( $('html, body').scrollTop()+1);
            }

        });


    }




};

$(function () {

    if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
        UTI.isdesktop = true;
        $(window).trigger('uti-device-changed');
    }
    else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
        UTI.isdesktop = false;
        $(window).trigger('uti-device-changed');
    }
    UTI.common.init();

    jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};
});


"use strict"

var TJ = (typeof TJ === 'object') ? TJ : {};

TJ.nav = {
    VAR: {},
    init: function () {

        var deskul = $('.mainnavi-desk .first-ul');
        var deskulroll = $('.mainnavi-desk .first-ul .roll-nav');
        var deskli = $('.mainnavi-desk .first-ul>li');
        var desklilen = $('.mainnavi-desk .first-ul>li').length;


        deskulroll.on('mouseout',' li.sub-head',function(){
            $(this).parent().parent().find('.image img').attr("src", $(this).parent().parent().find('.image img').attr('data-org'));
            console.log($(this).parent().parent().find('.image img').attr('data-org'));
        })

        deskulroll.on('mouseover',' li.sub-head',function(){
            if($(this).find('[data-img]').length)
            {
                $(this).parent().parent().find('.image img').attr("src",$(this).find('[data-img]').attr('data-img'));
            }
        })

        $(window).on('utiscroll',function(a,b,c){

            // if(c && b >= 200)
            if(b >= 500)
           {
               $('body').addClass('scroll-down');

           }
           else
           {
               $('body').removeClass('scroll-down');
           }

        });

        $('.mainnavi-mob .first-ul .level1 > a').click(function(e)
        {
            e.stopPropagation();
            e.preventDefault();
            $(this).parent().toggleClass('closed');

        });

        $('.footer-links .level1 > a').click(function(e)
        {
            e.stopPropagation();
            e.preventDefault();
            $(this).parent().toggleClass('closed');

        });



    }
};

$(function () {
    TJ.nav.init();
});
$(document).ready(function () {


    $('body').on('click', '.top_desktop .flyout, .nav-mob-wrapper .close-tab', function () {
        $('body').toggleClass('mob-open');
        $('.mobile-sub-wrap').height($(document).height());
        $('.flags').removeClass('opens');
    });

    $('body').on('click', '.search-mob', function () {
        $('.search-ico').trigger('click');
        $('.tbox').focus();
    });
    //place holder for mobile

    $('.bc-sf-search-suggestion-mobile-top-panel #bc-sf-search-box-mobile').attr('placeholder','Search');

    $('body').on('click','.bc-sf-search-btn-close-suggestion',function(){

        $('.search-wrap .close').trigger('click');
    });


    $('#header form #Search').on('focus', function () {
        $('#header .wrapper.desktop').addClass('search-mob-open');
    });
    $('#header form #Search').on('blur', function () {
        $('#header .wrapper.desktop').removeClass('search-mob-open');
    });

    $('body').on('click', '.mobileSearchClose', function () {

        $('#header .wrapper.desktop').removeClass('search-mob');
    });


    //remove link for toouc devices
    // alert(Modernizr.touchevents)
    if (Modernizr.touchevents) {
        $('.mainnavi-desk .desk-drop').attr('href', "#");
    }


    // new
    $('body').on('click', '.search-ico', function () {
        $('body').addClass('se-st');
        setTimeout(function(){
            $('body').addClass('se');
            $('.bc-sf-search-box').focus()

        },50);
    });

    $('body').on('click', '.search-wrap .close', function () {
        $('body').removeClass('se');
        setTimeout(function(){
            $('body').removeClass('se-st');
        },500);
    });


    jQuery('.flag-wrap .flag').on('click',function(){

        var newc = jQuery(this).find('div').text();

        if($(this).find('div').text() == "USD")
        {
            window.location.replace("https://us.tjswim.com" + document.location.pathname);
        }
        else if($(this).find('div').text() == "AUD")
        {
            window.location.replace("https://tjswim.com" + document.location.pathname);
        }


    });


    $('.main-right .cselect').click(function(){
        $(this).toggleClass('mobclick');
    });


    //geo-ip check
    var botPattern = "(googlebot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
    var re = new RegExp(botPattern, 'i');
    var bots = re.test(navigator.userAgent);


    var ccode = "";
    var ccc = "countrycheck4";

    var onSuccess = function(location){
        ccode = location.country.iso_code;

        if(ccode == "US")
        {
            window.location.replace("https://us.tjswim.com" + document.location.pathname);
        }else
        {
            var expDate = new Date();
            expDate.setTime(expDate.getTime() + (12 * 3600 * 1000));
            $.cookie(ccc, 'true', { expires: expDate });
        }

    };


    if(!jQuery.cookie(ccc) && !bots)
    {
        geoip2.country(onSuccess);
    }




});

"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};


UTI.ajaxcart = {
    VAR: {},

    init: function () {

      if (window.location.href.indexOf("minicart=true") > -1) {
        $('body,html').addClass('mini-cart');
        setTimeout(function(){
          $('body,html').addClass('mini-cart-ani');
        },500);
      }

        var _this = this;
        _this.updateCart();

        $('body').on('click', '#mini-cart .close-wrap .close, .empty-mini-cart-text a', function (e) {
            e.preventDefault();
            $('body').removeClass('mini-cart');
        });
        $('body').on('click', '.nav-close-cart, .minicart-back', function (e) {
          e.preventDefault();
          _this.closecart();
        });

        $('body').on('click', '.nav_cart', function (e) {
            e.preventDefault();
            $('body').addClass('mini-cart');
        });

        $(document).on('cart.requestComplete', function() {
            _this.updateCart()
        })


        $('body').on('click', '[data-directadd]', function (e) {
            e.preventDefault();
            _this.addItem($(this).attr('data-directadd'));
        });

        $('body').on('click', '.qty-step-btn', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = par.attr('data-count');
            if ($(this).find('.icon-minus').length) {
                qty--;
                if (qty < 0) qty = 0;
            }
            else {
                qty++;
            }
            _this.updateItem(par.attr('data-proid'), qty);

        });

        $('body').on('click', '.incart .remove', function (e) {
            e.preventDefault();
            var par = $(this).parents('.incart');
            var qty = 0;
            _this.updateItem(par.attr('data-proid'), qty);
        });


        // removing upsell
        $('body').on('click', '.remove.removeupsell', function (e) {
            e.preventDefault();
            $('#mini-cart').addClass("hide-upsell");
            jQuery.cookie("hideupsells","true");
        });

        $('body').on('click', '.show-upsell', function (e) {
            e.preventDefault();
            $('#mini-cart').removeClass("hide-upsell");
            jQuery.cookie("hideupsells","false");
        });

      $('body').on('change', '.quick-buy-cross select', function (e) {
        e.preventDefault();
        var varid = $(this).val();
        _this.addItem(varid);
      });


        $('body').on('submit', 'form[action="/cart/add"]', (function (e) {

            e.preventDefault();
            var $addToCartForm = $(this);
            var $addToCartBtn = $('.cart-btn button');
            $('#mini-cart').addClass('loading');

            $addToCartBtn.addClass('disabled').prop('disabled', true);
            $('body').addClass('mini-cart');

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                    $addToCartBtn.removeClass('disabled').prop('disabled', false);
                    document.body.classList.add('mini-cart')
                    _this.updateCart();
                },
                error: function (XMLHttpRequest) {
                    _this.updateCart();

                }
            });
            return false;

        }));


    },

    updateCart: function () {
      var _this = this;
      $('body,html').removeClass('mini-cart-ani');
        $.get("/cart?view=mini", function (data) {

            // $('#mini-cart .ajax_place').html($(data));
            // $('.offer-line.cart p').html($(data).find('.free-ship').html());

            // var counti = "";
            // if ($('.mini-header').attr('data-icount') != "0") {
            //     counti = $('.mini-header').attr('data-icount');
            // }

            // $('.nav_cart.nico span').text(counti);

          $('#mini-cart .ajax_place').html($(data));
          // console.log(data);

          var counti = $('[data-icount]').attr('data-icount');
          $('.header__cart-icon-count').text(counti);
          counti==0? $('.header__cart-icon-dot').removeClass('is-visible'): $('.header__cart-icon-dot').addClass('is-visible');
          _this.reloadOfferbar();

            //hide upsels
            if(jQuery.cookie("hideupsells"))
            {
                if(jQuery.cookie("hideupsells") == "true")
                {
                   $('#mini-cart').addClass("hide-upsell");
                }
            }


        }).done(function () {

          _this.animateCart();
          $('#mini-cart').removeClass('loading');
          $('body,html').addClass('mini-cart-ani');
          // _this.scrollbarmob();


        });
    }
    ,animateCart: function () {
  // to update and animate mini cart with total price
  var _this = this;

  $('.ns-target-gift').appendTo('.target-gifts');

  var locks = $('.target-locks .target');
  var rate = typeof market_exchange_rate !== 'undefined'? market_exchange_rate : 1;
  var progess_bar_val = $('.ns-progress').data('progress'); // total price
  var getBlockRate = function($el) {
    return $el.data('no-convert') ? 1 : rate;
  };
  var getTargetValue = function($el) {
    return $el.data('target') * getBlockRate($el);
  };

  var gifts = $('.ns-target-gift');
  for (var i = 0; i < gifts.length; i++) {
    var target = gifts.eq(i);
    var giftThreshold = target.attr('data-gift-target') * getBlockRate(target);
    if(progess_bar_val >= giftThreshold && target.hasClass('giftfalse') && target.hasClass('noappgift'))
    {
      _this.addItem(target.attr('data-gift-id'));
      return;
    }else if (progess_bar_val < giftThreshold && target.hasClass('gifttrue') && target.hasClass('noappgift'))
    {
      _this.updateItem(target.attr('data-gift-id'),0);
      return;
    }else if (target.hasClass('multigift'))
    {
      _this.updateItem(target.attr('data-gift-id'),1);
      return;
    }

  }

  var gap = 100 / (locks.length - 1);
  var current_target;
  var next_target;
  var last_target = locks.eq(locks.length - 1);
  locks.each(function(i){
    if(progess_bar_val >= getTargetValue($(this)))
    {
      var element = $(this);
      current_target = $(this);
      next_target = locks.eq(i+1);
      setTimeout(function() {
        element.addClass("active");
      }, 300 * i);
    }
  });

  if(locks.length <= 2) $('.mini-cart .top-wrap').hide();

  if(next_target) {
    if (next_target.length) {
      var currentVal = getTargetValue(current_target);
      var nextVal = getTargetValue(next_target);
      var extraval = (progess_bar_val - currentVal) / (nextVal - currentVal);
      var barwidth = (current_target.index() * gap) + (gap * extraval);
      $('.ns-progress-fill').width(barwidth + "%");
    } else {
      $('.ns-progress-fill').width("100%");
    }
  }

},

    addItem: function (id) {
        var _this = this;
        $('#mini-cart').addClass('loading');
        $('body').addClass('mini-cart');

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    }, updateItem: function (id, le) {
        var _this = this;
        $('#mini-cart').addClass('loading');

        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + le + "&id=" + id,
            dataType: "json",
            success: function (t) {
                _this.updateCart();
            },
            error: function (t, r) {
                _this.updateCart();
            }
        });
    },


  opencart: function () {

    $('body,html').addClass('mini-cart');
    setTimeout(function(){
      $('body,html').addClass('mini-cart-ani');
    },500);
  },
  closecart: function () {
    $('body,html').removeClass('mini-cart');
    setTimeout(function(){
      $('body,html').removeClass('mini-cart-ani');
    },500);
  },

  reloadOfferbar:function () {
    var rate = typeof market_exchange_rate !== 'undefined'? market_exchange_rate : 1;
    $('[data-target]').each(function () {
      var val = $(this).attr('data-target');
      var blockRate = $(this).data('no-convert') ? 1 : rate;
      if($(this).find('sp').length)
      {
        $(this).find('sp').text(Math.round(val * blockRate / 100));
      }

    });
  }


};


$(document).ready(function () {
    UTI.ajaxcart.init();

    var $addToCartBtn = $('.cart-btn button');


    $('body').on('submits', 'form[action="/cart/add"]', (function (e) {

        // $('form[action="/cart/add"]').submit(function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);

        $addToCartBtn.addClass('disabled').prop('disabled', true);
        // Add to cart.
        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize(),
            success: function (itemData) {
                console.log(itemData);
                $addToCartBtn.removeClass('disabled').prop('disabled', false);

                $('body').append('<div class="cart-added"><div class="box"><a class="close" href="#"></a><h2>IT\'S IN THE BAG</h2><a class="cont" href="#">Continue Shopping</a><a href="/cart" class="checkout"><span>CHECKOUT OUT NOW</span></a></div></div>');
                setTimeout(function () {
                    $('.cart-added').addClass('open');
                }, 100);


                updateicon();

            },
            error: function (XMLHttpRequest) {
                console.log('product adder');

            }
        });
        return false;


    }));


    function updateicon() {

    }

    $('body').on('click', '.cart-added .close,.cart-added .cont', function (e) {
        e.preventDefault();
        $('.cart-added').removeClass('open');
        setTimeout(function () {
            $('.cart-added').remove();
        }, 1000);

    });


});
"use strict"

var TJ = (typeof TJ === 'object') ? TJ : {};

TJ.producthover = {
    VAR: {},
    init: function () {



        //PDP
        var pdpVideo = '.product-single__video';
        if ($(pdpVideo).length) {
            $(document).on('click', pdpVideo, function (e) {
                if ($(pdpVideo)[0].paused) {
                    $(pdpVideo)[0].play();
                } else {
                    $(pdpVideo)[0].pause();
                }
            });
            $(pdpVideo)[0].onplaying = function () {
                $('.video-slide-preloader').fadeOut('slow');
            };
        }

        //PLP
        if ($('.pro-slide').length && UTI.isdesktop) {

            $(document).on('mouseenter','.pro-slide',function() {
                $(this).addClass('rolls');
                var myWrapper = $(this).find('.hovers img');
                if($(this).find('video').length) {
                    var me = $(this);
                    var myVideo = $(this).find('video');
                    myWrapper = $(this).find(myVideo);
                    var videoFile = myVideo.find('source').data('src');
                    var myPreloader = me.find('.video-preloader');

                    myWrapper.stop().fadeIn('fast');

                    if(!myVideo.hasClass('video-loaded')) {
                        myPreloader.show();
                        myVideo.find('source').attr('src',videoFile);
                        myVideo[0].load();

                        myVideo[0].onplaying = function() {
                            myPreloader.fadeOut();
                            myVideo.addClass('video-loaded');
                        };

                        myWrapper.stop().fadeIn();
                        myVideo[0].load();
                        myVideo[0].play();
                    } else {
                        if(myVideo[0].readyState === 4) {
                            myPreloader.hide();
                            myVideo.stop().fadeIn('fast');
                            myVideo[0].load();
                            myVideo[0].play();
                        }
                    }
                }
                else if ($(this).find('.image').length) {
                    myWrapper.stop().fadeIn();
                }
            });


            $(document).on('mouseleave','.pro-slide',function() {
                $(this).removeClass('rolls');

                var myWrapper = $(this).find('.hovers img');
                if($(this).find('video').length) {
                    var myVideo = $(this).find('video');
                    myWrapper = $(this).find(myVideo);
                    if(myVideo[0].readyState === 4) {
                        myVideo[0].pause();
                    }
                    myWrapper.stop().fadeOut();
                }
                else if ($(this).find('.image').length) {
                    myWrapper.stop().fadeOut();
                }
            });
        }


    }
};

$(function () {
    TJ.producthover.init();
});





/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
